import createIcon from '../../createIcon';

/**
 * @component @name LowPriority
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgNC41SDIyVjYuNUgxNFY0LjVaTTE0IDEwSDIyVjEySDE0VjEwWk0xNCAxNS41SDIyVjE3LjVIMTRWMTUuNVpNMiAxMUMyIDE0LjU4IDQuOTIgMTcuNSA4LjUgMTcuNUg5VjE5LjVMMTIgMTYuNUw5IDEzLjVWMTUuNUg4LjVDNi4wMiAxNS41IDQgMTMuNDggNCAxMUM0IDguNTIgNi4wMiA2LjUgOC41IDYuNUgxMlY0LjVIOC41QzQuOTIgNC41IDIgNy40MiAyIDExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LowPriority = createIcon('LowPriority', [
  [
    'path',
    {
      d: 'M14 4.5H22V6.5H14V4.5ZM14 10H22V12H14V10ZM14 15.5H22V17.5H14V15.5ZM2 11C2 14.58 4.92 17.5 8.5 17.5H9V19.5L12 16.5L9 13.5V15.5H8.5C6.02 15.5 4 13.48 4 11C4 8.52 6.02 6.5 8.5 6.5H12V4.5H8.5C4.92 4.5 2 7.42 2 11Z',
      key: '1ugxiv',
    },
  ],
]);

export default LowPriority;
